import React from 'react';
import { Box, Checkbox } from '@mui/material';

const RequiredField = ({ value, setFieldValue }) => {
    return (
        <Box>
            <Checkbox checked={Boolean(value)} onClick={(e) => setFieldValue('required', e.target.checked)} />
            Required
        </Box>
    );
};

export default RequiredField;
